import { GET_Manufacturer_LIST_Register } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
    ManufacturerList:[]
}

function ManufacturerRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_Manufacturer_LIST_Register:
            return {
                ...state,
                    ManufacturerList:action.payload.map(x=>({
                    Id:zeroPad(x.id,8),
                    description:x.description,
                    active:x.active                
                })) 
            }
        default:
           return state
    }  

}

export default ManufacturerRegister;